module.exports = __webpack_public_path__ + "static/media/FZLTXHB--B51-0.ef441062.svg";